var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.content)?_c('AlertComponent',_vm._b({attrs:{"theme":_vm.theme}},'AlertComponent',_vm.$attrs,false),[_c('span',{domProps:{"innerHTML":_vm._s(_vm.content)}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }